module.exports = __webpack_public_path__ + "static/Group 11-c9a79d937087c0c3a0a7c468c69659bd.png";